// extracted by mini-css-extract-plugin
export var columnList = "_c9-0";